import { useEffect } from "react";

function setTag(selector, create, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  value(el);
}

export default function usePageMeta({ title, description, canonical }) {
  useEffect(() => {
    document.title = title;
    setTag('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    }, (el) => el.setAttribute("href", canonical));
    setTag('meta[property="og:title"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:title");
      return m;
    }, (el) => el.setAttribute("content", title));
    setTag('meta[property="og:url"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:url");
      return m;
    }, (el) => el.setAttribute("content", canonical));
    if (description) {
      setTag('meta[name="description"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "description");
        return m;
      }, (el) => el.setAttribute("content", description));
      setTag('meta[property="og:description"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("property", "og:description");
        return m;
      }, (el) => el.setAttribute("content", description));
    }
  }, [title, description, canonical]);
}
